import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/Login.vue"),
    meta: {
      title: "Login",
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (store.getters["auth/loggedIn"]) {
      //     // Redirect to the home page instead
      //     next({ name: "default" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/Register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {

        if (store.getters["auth/loggedIn"]) {
          next({ name: "/" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgotPassword",
    name: "Forgot password",
    component: () => import("../views/account/ForgotPassword.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "/" });
        } else {
          next();
        }
      },
    },
  },


  {
    path: "/password-reset/:token",
    name: "resetPassword",
    component: () => import("../views/account/ResetPassword.vue"),
    meta: {
      title: "Reset Password",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "/" });
        } else {
          next();
        }
      },
    },
  },


  // {
  //   path: "/logout",
  //   name: "logout",
  //   meta: {
  //     title: "Logout",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       localStorage.clear();
  //       sessionStorage.clear();
  //       next();
  //     },
  //   },
  //   component: () => import("../views/account/LogOut.vue")
  // },


  {
    path: "/",
    name: "Dashboard",
    meta: {
      title: "Dashboard",
      permission: "default",
    },
    component: () => import("../views/dashboard/Dashboard.vue"),
  },

  {
    path: "/customers",
    name: "Customers",
    meta: {
      title: "Customers",
      permission: "default",
    },
    component: () => import("../views/customers/Customers.vue"),
  },
  {
    path: "/customers/:id",
    name: "Customers details",
    meta: {
      title: "Customers details",
      permission: "default",
    },
    component: () => import("../views/customers/CustomerDetails.vue"),
  },

  {
    path: "/companies",
    name: "Companies",
    meta: {
      title: "Companies",
      permission: "default",
    },
    component: () => import("../views/companies/Companies.vue"),
  },
  {
    path: "/companies/:id",
    name: "Companies details",
    meta: {
      title: "Companies details",
      permission: "default",
    },
    component: () => import("../views/companies/CompanyDetails.vue"),
  },

  {
    path: "/tickets",
    name: "Tickets",
    meta: {
      title: "Tickets",
      permission: "default",
    },
    component: () => import("../views/tickets/Tickets.vue"),
  },
  {
    path: "/tickets/:id",
    name: "Ticket Details",
    meta: {
      title: "Ticket Details",
      permission: "default",
    },
    component: () => import("../views/tickets/TicketDetails.vue"),
  },


  //settings
  {
    path: "/settings",
    name: "settings",
    meta: {
      title: "Settings",
    },
    component: () => import("../views/settings/Settings.vue"),
  },


  //profile
  // {
  //   path: "/profile/:id",
  //   name: "profile",
  //   meta: {
  //     title: "Profile",
  //   },
  //   component: () => import("../views/profile/Profile.vue"),
  // }, 

  //support
  // {
  //   path: "/support",
  //   name: "support",
  //   meta: {
  //     title: "Support",
  //   },
  //   component: () => import("../views/support/Support.vue"),
  // },
];